"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consideration__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "conduitController",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "BadContractSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "BadFraction",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "BadReturnValueFromERC20OnTransfer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
        ],
        name: "BadSignatureV",
        type: "error",
    },
    {
        inputs: [],
        name: "CannotCancelOrder",
        type: "error",
    },
    {
        inputs: [],
        name: "ConsiderationCriteriaResolverOutOfRange",
        type: "error",
    },
    {
        inputs: [],
        name: "ConsiderationLengthNotEqualToTotalOriginal",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "orderIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "considerationIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "shortfallAmount",
                type: "uint256",
            },
        ],
        name: "ConsiderationNotMet",
        type: "error",
    },
    {
        inputs: [],
        name: "CriteriaNotEnabledForItem",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "identifiers",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        name: "ERC1155BatchTransferGenericFailure",
        type: "error",
    },
    {
        inputs: [],
        name: "InexactFraction",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientNativeTokensSupplied",
        type: "error",
    },
    {
        inputs: [],
        name: "Invalid1155BatchTransferEncoding",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidBasicOrderParameterEncoding",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "InvalidCallToConduit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "conduitKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "InvalidConduit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "InvalidContractOrder",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "InvalidERC721TransferAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidFulfillmentComponentData",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "InvalidMsgValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidNativeOfferItem",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidProof",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "InvalidRestrictedOrder",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSigner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "InvalidTime",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "fulfillmentIndex",
                type: "uint256",
            },
        ],
        name: "MismatchedFulfillmentOfferAndConsiderationComponents",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "enum Side",
                name: "side",
                type: "uint8",
            },
        ],
        name: "MissingFulfillmentComponentOnAggregation",
        type: "error",
    },
    {
        inputs: [],
        name: "MissingItemAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "MissingOriginalConsiderationItems",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "NativeTokenTransferGenericFailure",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "NoContract",
        type: "error",
    },
    {
        inputs: [],
        name: "NoReentrantCalls",
        type: "error",
    },
    {
        inputs: [],
        name: "NoSpecifiedOrdersAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "OfferAndConsiderationRequiredOnFulfillment",
        type: "error",
    },
    {
        inputs: [],
        name: "OfferCriteriaResolverOutOfRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "OrderAlreadyFilled",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "enum Side",
                name: "side",
                type: "uint8",
            },
        ],
        name: "OrderCriteriaResolverOutOfRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "OrderIsCancelled",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "OrderPartiallyFilled",
        type: "error",
    },
    {
        inputs: [],
        name: "PartialFillsNotEnabledForOrder",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "identifier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenTransferGenericFailure",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "orderIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "considerationIndex",
                type: "uint256",
            },
        ],
        name: "UnresolvedConsiderationCriteria",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "orderIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "offerIndex",
                type: "uint256",
            },
        ],
        name: "UnresolvedOfferCriteria",
        type: "error",
    },
    {
        inputs: [],
        name: "UnusedItemParameters",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newCounter",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "offerer",
                type: "address",
            },
        ],
        name: "CounterIncremented",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "offerer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "zone",
                type: "address",
            },
        ],
        name: "OrderCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "offerer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "zone",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum ItemType",
                        name: "itemType",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct SpentItem[]",
                name: "offer",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "enum ItemType",
                        name: "itemType",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "address payable",
                        name: "recipient",
                        type: "address",
                    },
                ],
                indexed: false,
                internalType: "struct ReceivedItem[]",
                name: "consideration",
                type: "tuple[]",
            },
        ],
        name: "OrderFulfilled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OfferItem[]",
                        name: "offer",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ConsiderationItem[]",
                        name: "consideration",
                        type: "tuple[]",
                    },
                    {
                        internalType: "enum OrderType",
                        name: "orderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "totalOriginalConsiderationItems",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct OrderParameters",
                name: "orderParameters",
                type: "tuple",
            },
        ],
        name: "OrderValidated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "orderHashes",
                type: "bytes32[]",
            },
        ],
        name: "OrdersMatched",
        type: "event",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OfferItem[]",
                        name: "offer",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ConsiderationItem[]",
                        name: "consideration",
                        type: "tuple[]",
                    },
                    {
                        internalType: "enum OrderType",
                        name: "orderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "counter",
                        type: "uint256",
                    },
                ],
                internalType: "struct OrderComponents[]",
                name: "orders",
                type: "tuple[]",
            },
        ],
        name: "cancel",
        outputs: [
            {
                internalType: "bool",
                name: "cancelled",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "uint120",
                        name: "numerator",
                        type: "uint120",
                    },
                    {
                        internalType: "uint120",
                        name: "denominator",
                        type: "uint120",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "extraData",
                        type: "bytes",
                    },
                ],
                internalType: "struct AdvancedOrder",
                name: "",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "enum Side",
                        name: "side",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "criteriaProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct CriteriaResolver[]",
                name: "",
                type: "tuple[]",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "fulfillAdvancedOrder",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "uint120",
                        name: "numerator",
                        type: "uint120",
                    },
                    {
                        internalType: "uint120",
                        name: "denominator",
                        type: "uint120",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "extraData",
                        type: "bytes",
                    },
                ],
                internalType: "struct AdvancedOrder[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "enum Side",
                        name: "side",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "criteriaProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct CriteriaResolver[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "maximumFulfilled",
                type: "uint256",
            },
        ],
        name: "fulfillAvailableAdvancedOrders",
        outputs: [
            {
                internalType: "bool[]",
                name: "",
                type: "bool[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "maximumFulfilled",
                type: "uint256",
            },
        ],
        name: "fulfillAvailableOrders",
        outputs: [
            {
                internalType: "bool[]",
                name: "",
                type: "bool[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "considerationToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "address payable",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "offerToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "offerIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "offerAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "enum BasicOrderType",
                        name: "basicOrderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "offererConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "fulfillerConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "totalOriginalAdditionalRecipients",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct AdditionalRecipient[]",
                        name: "additionalRecipients",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct BasicOrderParameters",
                name: "parameters",
                type: "tuple",
            },
        ],
        name: "fulfillBasicOrder",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "considerationToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "address payable",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "offerToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "offerIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "offerAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "enum BasicOrderType",
                        name: "basicOrderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "offererConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "fulfillerConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "totalOriginalAdditionalRecipients",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct AdditionalRecipient[]",
                        name: "additionalRecipients",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct BasicOrderParameters",
                name: "parameters",
                type: "tuple",
            },
        ],
        name: "fulfillBasicOrder_efficient_6GL6yc",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order",
                name: "",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
        ],
        name: "fulfillOrder",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractOfferer",
                type: "address",
            },
        ],
        name: "getContractOffererNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "offerer",
                type: "address",
            },
        ],
        name: "getCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "counter",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OfferItem[]",
                        name: "offer",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ConsiderationItem[]",
                        name: "consideration",
                        type: "tuple[]",
                    },
                    {
                        internalType: "enum OrderType",
                        name: "orderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "counter",
                        type: "uint256",
                    },
                ],
                internalType: "struct OrderComponents",
                name: "",
                type: "tuple",
            },
        ],
        name: "getOrderHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "getOrderStatus",
        outputs: [
            {
                internalType: "bool",
                name: "isValidated",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "isCancelled",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "totalFilled",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalSize",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "incrementCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "newCounter",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "information",
        outputs: [
            {
                internalType: "string",
                name: "version",
                type: "string",
            },
            {
                internalType: "bytes32",
                name: "domainSeparator",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "conduitController",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "uint120",
                        name: "numerator",
                        type: "uint120",
                    },
                    {
                        internalType: "uint120",
                        name: "denominator",
                        type: "uint120",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "extraData",
                        type: "bytes",
                    },
                ],
                internalType: "struct AdvancedOrder[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "enum Side",
                        name: "side",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "criteriaProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct CriteriaResolver[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "offerComponents",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "considerationComponents",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Fulfillment[]",
                name: "",
                type: "tuple[]",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "matchAdvancedOrders",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "offerComponents",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "considerationComponents",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Fulfillment[]",
                name: "",
                type: "tuple[]",
            },
        ],
        name: "matchOrders",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order[]",
                name: "",
                type: "tuple[]",
            },
        ],
        name: "validate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Consideration__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(conduitController, overrides) {
        return super.getDeployTransaction(conduitController, overrides || {});
    }
    deploy(conduitController, overrides) {
        return super.deploy(conduitController, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Consideration__factory = Consideration__factory;
Consideration__factory.bytecode = _bytecode;
Consideration__factory.abi = _abi;
//# sourceMappingURL=Consideration__factory.js.map